import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles((theme) => ({
        root: {
          flexGrow: 1,
          width: '100%'
        },
        companyHeadings: { backgroundColor: '#4688f0', color: '#fff' },
        heading: {
          fontSize: theme.typography.pxToRem(15),
          fontWeight: theme.typography.fontWeightRegular,
        },
        ButtonSkip:{
          left:"10px"
        },
        NextButton:{
          left:"5px"
        },
        BackButton:{
          right:"-6px"
        },
        footerBackground:{
          background:"#f7f7f7"

        },
        CardBorder: {
          borderRadius: "15px"
      
        },
        cardScrollArea: {
          //maxHeight: "72vH",
          //overflowX: "hidden",
          //overflowX: "hidden",
  
        },
        widthFill: { width: '100%' },
        customInputs: { width: '100%' },
        addPlus: {},
        addMinus: {},
        profileImg: {}
      }));